/** PVD wording from Dan’s Recommendation — PV only 2026 v2, with duplicate paragraphs removed. */
import { GENERAL_RECOMMENDATION_WORDING } from './assessment-library.data.js';
export const PV_GENERAL_RECOMMENDATION_WORDING = [
    'At time of inspections the inspector did not sight the documentation. As it cannot be confirmed or denied if the documentation was handed over to the homeowners these items will not be displayed in the final report. It would be advised to review AS/NZS 5033 and AS/NZS 4777, to confirm if documentation was actually provided to the homeowners.',
    'Please note that a separate report will be generated for the battery storage unit installation.',
    'Please note that this inspection is of a system upgrade. Due to varying requirements in states or difficulty of determining who has installed or altered different parts of the system, this report may include issues that are not the responsibility of the recipient. If you cannot determine which inspection items are your responsibility, it is recommended that you consult the relevant state regulator to help identify the responsible party.',
    'Please note that this inspection is of the original part of a system that has subsequently been added to. Due to varying requirements in states or difficulty of determining who has installed or altered different parts of the system, this report may include issues that are not the responsibility of the recipient. If you cannot determine which inspection items are your responsibility, it is recommended that you consult the relevant state regulator to help identify the responsible party.',
    'The homeowner was not present at time of the inspection and therefore the inspector was unable to access the roof cavity. Please confirm DC wiring within the roof and wall cavities are adequately protected within HD conduit, labelled correctly and secured as per the standards. Please also confirm AC cable from main switchboard to the inverter are installed correctly as per AS/NZS 3000:2018.',
    'At time of inspection the customer did not give consent for with the inspector to enter the house and therefore the inspector was unable to access the roof cavity. Please confirm DC wiring within the roof and wall cavities are adequately protected within HD conduit, labelled correctly and secured as per the standards. Please also confirm AC cable from main switchboard to the inverter are installed correctly as per AS/NZS 3000:2018.',
    'The array is installed at a tilt of less than 10°. A minimum tilt of 10° is recommended to assist with self-cleaning and reduce soiling accumulation.',
    'Please note, at the time of the inspection the inspector observed roof tiles that have been damaged and silicone has been applied to them to rejoin. It would be recommended to replace these badly broken tiles to ensure no water ingress. As the inspector cannot confirm or deny if this was from the solar installation this note is only a general recommendation.',
    'The grid metering equipment has not been sealed. At present the meter and isolation links are unsealed. Please ensure to obtain appropriate documentation and submit forms to the local DNSP to have devices sealed as per the requirements of the DNSP.',
];
export function generalRecommendationWording(jobId) {
    return jobId.toUpperCase().startsWith('PVD')
        ? PV_GENERAL_RECOMMENDATION_WORDING
        : GENERAL_RECOMMENDATION_WORDING;
}
export const PV_NON_CHECKLIST_ITEMS = new Map([
    [
        'P1',
        {
            group: 0,
            item: 0,
            description: 'Roof mounted [ R ] Building integrated [ B ] Freestanding [ F ]',
        },
    ],
    [
        'P10',
        {
            group: 0,
            item: 1,
            description: 'Energy output expressed as a % of maximum output based on tilt and orientation using the [PV-GC tool/equivalent]',
        },
    ],
    [
        'P11',
        {
            group: 0,
            item: 2,
            description: 'Energy output as a % based on shading alone, using Solar Pathfinder Annual Average Output',
        },
    ],
    [
        'P12',
        {
            group: 0,
            item: 3,
            description: 'Total Energy output calculated in relation to total energy available at specific site',
        },
    ],
    [
        'P13',
        {
            group: 0,
            item: 4,
            description: 'In the performance estimate provided as part of the system’s documentation: was the customer informed of expected output?',
        },
    ],
    ['P14', { group: 0, item: 5, description: 'Is Inverter in full sun for part of the day?' }],
    ['P15', { group: 0, item: 6, description: 'Estimate percentage of sunlight hours exposed' }],
    ['P2', { group: 0, item: 7, description: 'PV Array tilt' }],
    ['P3', { group: 0, item: 8, description: 'PV Array orientation' }],
    [
        'P5',
        {
            group: 0,
            item: 9,
            description: 'The whole PV array is installed on roof area/s that faces only one direction.',
        },
    ],
    ['P6', { group: 0, item: 10, description: 'Is there any shading of the array?' }],
    [
        'P7',
        {
            group: 0,
            item: 11,
            description: 'Describe the shading identified by type: (i) topography, (ii) vegetation, (iii) buildings, (iv) other.',
        },
    ],
    [
        'P8',
        {
            group: 0,
            item: 12,
            description: 'Is the shading present every day or only just for part/s of the year?',
        },
    ],
    [
        'P9',
        {
            group: 0,
            item: 13,
            description: 'Does the shading cover the whole system or only a % of the array?',
        },
    ],
]);
/** Counts opt in to calculation; historical manually recorded totals remain readable. */
export function calculateArrayTotals(hardware) {
    const next = { ...hardware };
    const module = hardware.modules[hardware.arrayModuleIndex ?? (hardware.modules.length === 1 ? 0 : -1)];
    if (hardware.panelsInLongestString !== undefined)
        next.totalArrayVoltageOpenCircuitV =
            module?.voltageOpenCircuitV !== undefined
                ? Number((module.voltageOpenCircuitV * hardware.panelsInLongestString).toFixed(4))
                : undefined;
    if (hardware.numberOfStrings !== undefined)
        next.totalArrayCurrentShortCircuitA =
            module?.currentShortCircuitA !== undefined
                ? Number((module.currentShortCircuitA * hardware.numberOfStrings).toFixed(4))
                : undefined;
    return next;
}
//# sourceMappingURL=report-extras.js.map